const store = {
  namespaced: true,
  state: {
    storeSearchForm: {},
    storeSearchList: {}
  },
  getters: {},
  mutations: {
    setSearchForm(state, data) {
      state.storeSearchForm = data;
    },
    setSearchList(state, data) {
      state.storeSearchList = data;
    }
  },
  actions: {
    async queryPartsSalesList({ rootState }, params = {}) {
      const data = await rootState.http("/report/partsSalesReport/pc", params);
      return data;
    },
    async queryReceiptReportList({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/list/byReceiptType", params);
      return data;
    },
    async queryReceiptReportDetail({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/report/byReceiptType", params);
      return data;
    },
    async queryInvoicing({ rootState }, params = {}) {
      const data = await rootState.http("/psi/queryPsi", params);
      return data;
    }
  }
};

export default store;
